import React, { useEffect, useState } from "react";
import Navbar from "../widgets/Navbar";
import PartnerSidebar from "../widgets/PartnerSidebar";
import { useTranslation } from "react-i18next";
import { useGetUserReferListQuery } from "../../redux/accountApi";
import { useSelector } from "react-redux";

const PartnerNetwork = () => {
  const { t } = useTranslation();
  const userSegment = useSelector((state) => state.user);
  const { data: userListRefer } = useGetUserReferListQuery();
  const [treeRoot, setTreeRoot] = useState(null);

  useEffect(() => {
    const user = userSegment?.userData || {};

    if (userListRefer && user.id) {
      const root = {
        id: user.id,
        name: user.user_name || user.email,
        isSelf: true,
        children: userListRefer.map((child) => ({
          id: child.userId,
          name: child.user_name || child.email,
          deposit: child.deposit || 0,
          account_balance: child.account_balance || 0,
          children: [],
        })),
      };
      setTreeRoot(root);
    }
  }, [userListRefer, userSegment]);

  const ReferralNode = ({ user }) => (
     <li> 
      <i className="bi bi-person-circle"></i>
      <div className="t_box ">
        <strong>{user.name}</strong>
        {!user.isSelf && (
          <>
            
            Deposit: ${user.deposit}
            <br />
            Balance: ${user.account_balance}
          </>
        )}
      </div>
       
      {user.children && user.children.length > 0 && (
        <ul>
          {user.children.map((child) => (
            <ReferralNode key={child.id} user={child} />
          ))}
        </ul>
      )}  
    </li>
   
    
  );

  return (
    <div>
      <Navbar />
      <section className="p70  pt-md-5 pb-md-5">
        <div className="container ">
          <div className="row ">
        <PartnerSidebar />
        <div className="col-xl-9 col-lg-8">
        <div className="p-3 p-md-4 bg2 br10">
       
          <h5 className="mb-2">{t("Referral Tree View")}</h5>
          <div className="tree">
          <ul>
          {treeRoot ? (
            <ReferralNode user={treeRoot} />
          ) : (
            <p>{t("Loading referral data...")}</p>
          )}
              </ul>  
        </div>
        </div>
        </div>
        </div>
        </div>
      </section>
    </div>
  );
};

export default PartnerNetwork;
